import * as _ from 'lodash';
import { Notifier } from '../../services/util/PubSub';

export class Record {
  public message: string;
  public level: string;

  constructor(message: string, level: string) {
    this.message = message;
    this.level = level;
  }
}

export enum RecordTypes {
  INFO = 'info',
  ERROR = 'error'
}

export class Logger extends Notifier {
  private alerts: Record[] = [];

  addAlert(msg: string, level?: string) {
    const infoMessage = "Note: " + msg;
    this.alerts.push(new Record(infoMessage, _.isString(level) ? level : RecordTypes.INFO));
    this.publish();
  }

  addError(msg: string) {
    const errorMessage = "Error: " + msg;
    this.alerts.push(new Record(errorMessage, RecordTypes.ERROR));
    this.publish();
  }

  getAlerts() {
    return this.alerts;
  }

  clearAlerts(level?: string) {
    if (_.isUndefined(level)) {
      this.alerts = [];
    } else {
      _.remove(this.alerts, (alert) => level === alert.level);
    }
  }
};


// WEBPACK FOOTER //
// ./src/stores/logger/Logger.ts